import { useWebSocket } from '@/hooks/useWebSocket';

/**
 * Mantém uma única conexão WebSocket viva pela vida toda da sessão. Montado
 * no nível do App (irmão das Routes) para não desmontar entre navegações,
 * incluindo trocas entre /app/* e rotas fora do DashboardLayout (ex:
 * /app/flows/new). O hook já é no-op quando o usuário não está autenticado.
 */
export function WebSocketManager() {
  useWebSocket();
  return null;
}
